// Import Vue composition API functions
import { ref } from 'vue';
// Import defineStore from Pinia
import { defineStore } from 'pinia';

// Define the useUserStore function
const useUserStore = defineStore('user', () => {
  // Login flag
  const loginFlag = ref(localStorage.getItem('loginFlag'));
  // User ID
  const director_id = ref(localStorage.getItem('director_id'));
  // Department ID
  const department_id = ref(localStorage.getItem('department_id'));
  // Multi department status (0=单科室, 1=多科室)
  const multi_status = ref(localStorage.getItem('multi_status') || '0');
  // Multi department type (assessment, formalassessment, nightShift, etc.)
  const multi_type = ref(localStorage.getItem('multi_type') || 'assessment');

  // Function to update user and department IDs
  function updateUserIdAndDepartmentId(newId, newDepartmentId) {
    localStorage.setItem('director_id', newId);
    localStorage.setItem('department_id', newDepartmentId);
    director_id.value = newId;
    department_id.value = newDepartmentId;
  }

    // Function to update the department ID
    function updateDepartmentId(newDepartmentId) {
      localStorage.setItem('department_id', newDepartmentId);
      department_id.value = newDepartmentId;
    }

  // Function to update multi department info
  function updateMultiInfo(newMultiStatus, newMultiType) {
    localStorage.setItem('multi_status', newMultiStatus);
    localStorage.setItem('multi_type', newMultiType);
    multi_status.value = newMultiStatus;
    multi_type.value = newMultiType;
  }
  
  return {
    loginFlag,
    director_id,
    department_id,
    multi_status,
    multi_type,
    updateDepartmentId,
    updateUserIdAndDepartmentId,
    updateMultiInfo
  }
});

export default useUserStore;
